/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ParameterData} from "./ParameterData";

export class LocateFilter {
  name: string;
  connection = "or";
  parameters: ParameterData[];
  saved = false;
}
